package com.example.mystybag.login.model

// Simple UI state for the add location prompt screen
data class AddLocationPromptUIState(
    val dummy: Boolean = true // Data class must have at least one parameter
)
